var exports = {
  "kL": "xa15a2ab7--b035bf--container",
  "HU": "xa15a2ab7--b035bf--aside",
  "Uo": "xa15a2ab7--b035bf--buttons",
  "x6": "xa15a2ab7--b035bf--button",
};

module.exports = exports;
